export default __webpack_public_path__ + "static/media/badge-3.6ead7feb.png";